import { useQuery } from "@tanstack/react-query";
import { api } from "./api";

export const useProducts = () =>
  useQuery({
    queryKey: ["products"],
    queryFn: async () => {
      const r = await api.get("/products");
      return Array.isArray(r.data) ? r.data : [];
    },
  });

export const useStoreInfo = () =>
  useQuery({
    queryKey: ["store-info"],
    queryFn: async () => (await api.get("/store-info")).data ?? {},
  });
